export function asignacionMasivaUnidadOrganizacionalNormalize(row) {
    return {
        idAsignacionMasivaUnidadOrganizacional: row.idAsignacionMasivaUnidadOrganizacional ?? row.IdAsignacionMasivaUnidadOrganizacional ?? 0,
        idCurso: row.idCurso ?? row.IdCurso ?? 0,
        idUnidadOrganizacional: row.idUnidadOrganizacional ?? row.IdUnidadOrganizacional ?? 0,
        fechaLimite: row.fechaLimite ?? row.FechaLimite ?? null,
        activo: row.activo ?? row.Activo ?? false,
    };
}
